import { AmplitudeCategories, createTrackerForCategory } from "./amplitude";

const trackEvent = createTrackerForCategory(AmplitudeCategories.TeamResources);

enum events {
    DiscoverTeamPlan = "DiscoverTeamPlan",
}

export function DiscoverTeamPlan() {
    trackEvent(events.DiscoverTeamPlan, {}, { audit: true });
}
